(function initializeCateringBookingDialogs() {
  if (window.__cateringBookingDialogsLoaded) return;
  window.__cateringBookingDialogsLoaded = true;

  const labels = ['Next: Event Style', 'Next: Event Details', 'Next: Additional Details', 'Review Request', 'Submit Request'];
  const fieldMap = {
    first_name: 'lead_first_name', last_name: 'lead_last_name', email_address: 'lead_email_address', phone_number: 'lead_phone_number', phone_number_extension: 'lead_phone_number_extension', company: 'lead_company',
    event_style: 'lead_event_style', event_description: 'lead_event_description', start_time: 'lead_start_time', end_time: 'lead_end_time', guest_count: 'lead_guest_count',
    address1: 'lead_offsite_address_attributes_address1', city: 'lead_offsite_address_attributes_city', state: 'lead_offsite_address_attributes_state', zip_code: 'lead_offsite_address_attributes_zip_code', delivery_instructions: 'lead_delivery_instructions',
    additional_information: 'lead_additional_information', referral_source_id: 'lead_referral_source_id', referral_source_other: 'lead_referral_source_other'
  };

  function formatDate(value) {
    if (!value) return '';
    const [year, month, day] = value.split('-');
    return year && month && day ? `${month}/${day}/${year}` : value;
  }

  function formatTime(value) {
    if (!value) return '';
    const [hour, minute] = value.split(':').map(Number);
    const suffix = hour >= 12 ? 'PM' : 'AM';
    return `${((hour + 11) % 12) + 1}:${String(minute || 0).padStart(2, '0')} ${suffix}`;
  }

  function setup(dialog) {
    if (dialog.hasAttribute('data-venue-booking-dialog')) return;
    if (dialog.dataset.bookingInitialized === 'true') return;
    dialog.dataset.bookingInitialized = 'true';
    const form = dialog.querySelector('[data-booking-form]');
    const steps = Array.from(dialog.querySelectorAll('[data-booking-step]'));
    const intros = Array.from(dialog.querySelectorAll('[data-booking-intro]'));
    const next = dialog.querySelector('[data-booking-next]');
    const back = dialog.querySelector('[data-booking-back]');
    const actions = dialog.querySelector('[data-booking-actions]');
    const success = dialog.querySelector('[data-booking-success]');
    const successActions = dialog.querySelector('[data-booking-success-actions]');
    const error = dialog.querySelector('[data-booking-error]');
    const delivery = dialog.querySelector('[data-booking-delivery-fields]');
    const referralOther = dialog.querySelector('[data-booking-referral-other]');
    const provider = dialog.querySelector('[data-booking-provider-form]');
    let step = 1;
    let trigger = null;
    let submitting = false;

    function normalizeProviderForm() {
      const embeddedForms = Array.from(dialog.querySelectorAll('#tripleseat_embed_form'));
      if (!embeddedForms.length) return null;

      const primaryForm = embeddedForms.find((embeddedForm) => provider.contains(embeddedForm)) || embeddedForms[0];
      if (!provider.contains(primaryForm)) provider.appendChild(primaryForm);
      embeddedForms.forEach((embeddedForm) => {
        if (embeddedForm !== primaryForm) embeddedForm.remove();
      });
      return primaryForm;
    }

    const providerObserver = new MutationObserver(() => normalizeProviderForm());
    providerObserver.observe(dialog, { childList: true, subtree: true });
    normalizeProviderForm();

    function values() { return Object.fromEntries(new FormData(form).entries()); }
    function setError(message) { error.textContent = message || ''; error.hidden = !message; }
    function updateConditionalFields() {
      const data = values();
      const isDelivery = data.event_style === 'dropoff';
      delivery.hidden = !isDelivery;
      ['address1', 'city', 'state', 'zip_code'].forEach((name) => form.elements[name].required = isDelivery);
      referralOther.hidden = data.referral_source_id !== '1';
    }
    function reviewRow(label, value, editStep) { return `<div><dt>${label}</dt><dd>${value || '—'}${editStep ? `<button type="button" data-booking-edit="${editStep}">Edit</button>` : ''}</dd></div>`; }
    function renderSummary() {
      const data = values();
      const escape = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
      Object.keys(data).forEach((key) => { data[key] = escape(data[key]); });
      const style = { onpremise: 'On-Premise Event', dropoff: 'Delivery', pickup: 'Pickup' }[data.event_style] || '—';
      const contact = [data.first_name, data.last_name].filter(Boolean).join(' ');
      const detail = [formatDate(data.event_date), `${formatTime(data.start_time)} – ${formatTime(data.end_time)}`].filter(Boolean).join(', ');
      const summary = [reviewRow('Contact', [contact, data.email_address, data.phone_number].filter(Boolean).join('<br>'), 1), reviewRow('Event Style', style, 2), reviewRow('Event Type', data.event_description, 3), reviewRow('Date & Time', detail, 3), reviewRow('Guests', data.guest_count ? `${data.guest_count} People` : '', 3), reviewRow('Additional Details', data.additional_information, 4), reviewRow('How Did You Hear About Us?', form.elements.referral_source_id.selectedOptions[0]?.text || '', 4)].join('');
      dialog.querySelector('[data-booking-review]').innerHTML = summary;
      dialog.querySelector('[data-booking-mini-summary]').innerHTML = `<strong>Your Request Summary</strong><button type="button" data-booking-edit="1">Edit</button><p>${contact || 'Your contact'}<br>${style}<br>${data.guest_count ? `${data.guest_count} guests` : ''}</p>`;
    }
    function showStep(nextStep) {
      step = nextStep;
      setError(''); updateConditionalFields(); renderSummary();
      steps.forEach((section) => { const active = Number(section.dataset.bookingStep) === step; section.hidden = !active; section.classList.toggle('is-active', active); });
      intros.forEach((panel) => panel.classList.toggle('is-active', Number(panel.dataset.bookingIntro) === step));
      dialog.querySelector('[data-booking-step-label]').textContent = `STEP ${step} OF 5`;
      back.hidden = step === 1;
      next.textContent = labels[step - 1];
      const focusTarget = steps[step - 1].querySelector('input, select, textarea, button');
      focusTarget?.focus();
    }
    function validateCurrentStep() {
      updateConditionalFields();
      const controls = Array.from(steps[step - 1].querySelectorAll('input, select, textarea')).filter((control) => !control.disabled && control.required);
      const invalid = controls.find((control) => !control.checkValidity());
      if (!invalid) return true;
      invalid.reportValidity();
      return false;
    }
    function syncProvider() {
      normalizeProviderForm();
      const data = values();
      Object.entries(fieldMap).forEach(([name, id]) => {
        const input = provider.querySelector(`#${id}`);
        if (input) input.value = data[name] || '';
      });
      const date = provider.querySelector('#lead_event_date');
      if (date) date.value = formatDate(data.event_date);
      const optIn = provider.querySelector('#lead_email_opt_in');
      if (optIn) optIn.checked = data.email_opt_in === '1';
    }
    function mapProviderErrors(errors) {
      const first = Object.values(errors || {}).flat()[0];
      if (first) setError(first);
      const keys = Object.keys(errors || {}).join(' ').toLowerCase();
      if (/first|last|email|phone|company/.test(keys)) showStep(1);
      else if (/style/.test(keys)) showStep(2);
      else if (/event|date|time|guest|address|delivery|postal|city|state/.test(keys)) showStep(3);
      else showStep(4);
    }
    function submit() {
      if (submitting) return;
      submitting = true; setError(''); next.disabled = true; next.textContent = 'Submitting…'; syncProvider();
      const leadForm = window.TS?.lead_form_embed;
      if (!leadForm || !provider.querySelector('#lead_submit')) {
        submitting = false; next.disabled = false; next.textContent = labels[4]; setError('The booking form is still loading. Please try again in a moment.'); return;
      }
      const originalErrors = leadForm.insert_lead_form_error_list;
      window.TS.custom_success_callback = function () {
        submitting = false; success.hidden = false; actions.hidden = true; successActions.hidden = false;
        steps.forEach((section) => section.hidden = true); intros.forEach((panel) => panel.classList.remove('is-active'));
        dialog.querySelector('[data-booking-step-label]').hidden = true;
        dialog.querySelector('[data-booking-success-email]').textContent = form.elements.email_address.value ? `A confirmation has been sent to ${form.elements.email_address.value}` : '';
        dialog.querySelector('[data-booking-close]')?.focus();
      };
      leadForm.insert_lead_form_error_list = function (errors, bookingErrors) {
        submitting = false; next.disabled = false; next.textContent = labels[4]; mapProviderErrors(errors || bookingErrors || {});
        return originalErrors.call(this, errors, bookingErrors);
      };
      leadForm.submit_lead();
    }
    function reset() {
      form.reset(); step = 1; submitting = false; success.hidden = true; actions.hidden = false; successActions.hidden = true; dialog.querySelector('[data-booking-step-label]').hidden = false; next.disabled = false; updateConditionalFields(); showStep(1);
    }
    dialog.addEventListener('booking:open', (event) => { trigger = event.detail?.trigger || document.activeElement; reset(); });
    dialog.addEventListener('close', () => {
      normalizeProviderForm();
      trigger?.focus?.();
    });
    form.addEventListener('change', updateConditionalFields);
    next.addEventListener('click', () => { if (!validateCurrentStep()) return; if (step < 5) showStep(step + 1); else submit(); });
    back.addEventListener('click', () => showStep(step - 1));
    dialog.addEventListener('click', (event) => {
      const close = event.target.closest('[data-booking-close]');
      if (close) { dialog.close(); return; }
      const edit = event.target.closest('[data-booking-edit]');
      if (edit) showStep(Number(edit.dataset.bookingEdit));
      if (event.target === dialog) dialog.close();
    });
    updateConditionalFields();
  }

  function open(dialog, trigger) {
    setup(dialog);
    if (!dialog.open) dialog.showModal();
    dialog.dispatchEvent(new CustomEvent('booking:open', { detail: { trigger } }));
  }
  window.CateringBookingDialog = { open };
  document.querySelectorAll('[data-catering-booking-dialog]').forEach(setup);
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('a[href^="#"]');
    if (!trigger) return;
    const dialog = document.getElementById(trigger.getAttribute('href').slice(1));
    if (!(dialog instanceof HTMLDialogElement) || !dialog.matches('[data-catering-booking-dialog]')) return;
    event.preventDefault(); open(dialog, trigger);
  });
})();
